import { authClient } from '../better-auth'

export interface MagicLinkOptions {
  redirectTo?: string
  inviteToken?: string
  shouldCreateUser?: boolean
}

function callbackUrl(opts: MagicLinkOptions): string {
  const params = new URLSearchParams()
  if (opts.redirectTo) params.set('next', opts.redirectTo)
  if (opts.inviteToken) params.set('invite', opts.inviteToken)
  const query = params.toString()
  return `${window.location.origin}/auth/callback${query ? `?${query}` : ''}`
}

export async function sendMagicLink(email: string, opts: MagicLinkOptions = {}): Promise<void> {
  const result = await authClient.signIn.magicLink({
    email,
    callbackURL: callbackUrl(opts),
    errorCallbackURL: `${window.location.origin}/login`,
  })
  if (result.error) throw new Error(result.error.message ?? 'Could not send sign-in link')
}

export async function signOut(): Promise<void> {
  const result = await authClient.signOut()
  if (result.error) throw new Error(result.error.message ?? 'Could not sign out')
}

export async function getCurrentSession() {
  const result = await authClient.getSession()
  if (result.error) throw new Error(result.error.message ?? 'Could not load session')
  return result.data
}

export function landingPathForRole(role: string | null | undefined): string {
  if (role === 'actor') return '/actor'
  if (role === 'supervisor') return '/supervisor'
  if (role === 'owner' || role === 'member') return '/producer'
  return '/account'
}
